import classNames from 'classnames'

import { PlaceArrowBackIcon, PlaceCloseIcon } from '@local/assets/icons'
import { CLICK_CODE } from '@local/utils'

import { ClickEvent } from '@web/types'
import Clickable from '@web/ui/components/Clickable'

import styles from './ContentWithMap.module.scss'

export const HEIGHT_HANDLE = 25

interface MapFloatingButtonsProps {
  showBackButton?: boolean
  onClickBack?: (e: ClickEvent) => void
  onClickClose?: (e: ClickEvent) => void
  showCloseButton?: boolean
}
function BackButtonArea(props: MapFloatingButtonsProps) {
  const { showBackButton, showCloseButton, onClickBack, onClickClose } = props

  return (
    <>
      {/* 플로팅 버튼 */}
      {showBackButton && (
        <Clickable
          // nClickCode={CLICK_CODE['timelinepg.back']}
          className={classNames(styles.btn_floating, styles.type_back)}
          onClick={onClickBack}
        >
          <PlaceArrowBackIcon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">이전 페이지</span>
        </Clickable>
      )}
      {showCloseButton && (
        <Clickable
          nClickCode={CLICK_CODE['timelinepg.cancel']}
          className={classNames(styles.btn_floating, styles.type_close)}
          onClick={onClickClose}
        >
          <PlaceCloseIcon className={styles.icon} aria-hidden="true" />
          <span className="place_blind">닫기</span>
        </Clickable>
      )}
    </>
  )
}

export default BackButtonArea
